
import { Watch, ComponentService, ComponentFilter, BaseTLTableComponent, AxiosResponse, RightHelper, BaseTLTableBase, tlISODateTimeToLocalNoSecondsString, tlResponseToUptimeString } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class ComponentListBase extends BaseTLTableComponent {

		componentService: ComponentService = new ComponentService();
		protected right_Provisioning = false;

	 showAllertToDeleteClickBase(itemsSelected: any) {
			this.showAlertBeforeActionClickBase(itemsSelected, this.$t('component.messageQuestionMain').toString(), true);		
		}

		showButtonAdd(): boolean {
			return this.right_Provisioning;
		}

		showAlertToAddClickBase(itemsSelected: any) {
			let id = itemsSelected.id;
			if (id) {
				itemsSelected = id;
			}
			this.showAlertBeforeActionClickBase(itemsSelected, this.$t('component.messageQuestionMainAdd').toString(), false);
		}

		callActionClick() {
			if (this.itemsSelected) {
				let idList: number[] = this.getSelectedList();
				if (this.isDelete) {
					this.deleteSelected(idList);
				}
				else {
					this.addSelected(idList);
				}
			}
			this.itemsSelected = null;
			(this.$refs.componentsTable as BaseTLTableBase).clearSelected();
		}

		deleteSelected(idList: number[]) {
			if (idList.length > 0) {
				// VaPTODO - schovavame dialog, ktery vytvori base-tl-table, na zaklade jeho identifikatoru a pritom ani nevime, zda byl otevreny a ze se stale jmenuje stejne... a to neni dobre
				this.$bvModal.hide('popupDialog');
				this.isBusy = true;
				this.deleteItemsList = idList;
				super.deleteList();	
		
			}
		}

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return this.componentService.deleteList(this.deleteItemsList);
	}

		moreActionAddAllowBase(): boolean {		
			for (var i = 0; i < this.selectItems.length; i++) {
				if (this.tableData.filter(c => c.id == this.selectItems[i] && c.isWaitingForAcceptProvisioning).length > 0) {
					return true && this.canUpdate && RightHelper.currentUserHasRight('COR_Component_Provisioning');
				}
			}
			return false;
		}

		addSelected(idList: number[]) {
			if (idList.length > 0) {
				this.isBusy = true;
				this.addList(idList).then(() => this.fetchData())
					.catch((error) => {
						var errorMessage = this.$t('component.errorAdd').toString();
						super.showAlertModalWithErrorMessageList(errorMessage);
						this.isBusy = false;
					});
			}
		}

		addList(idList: number[]): Promise<AxiosResponse<any>> {
			return this.componentService.acceptProvisionList(idList);
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: ComponentFilter = new ComponentFilter(this.$store.state.idTenant, false, null, null, null, null);
			return this.componentService.getAllByFilter(filter);
		}
		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		prepareItems(items: any[]) {
		}

		setFields() {
			this.fields = [
				{ key: 'name', label: this.$t('component.fieldName'), trans: 'component.fieldName', sortable: true, class: 'text-left', optional: false, visible: true, design: 'detail' },
				{ key: 'idComponentStateNavigationName', label: this.$t('component.fieldStatus'), trans: 'component.fieldStatus', sortable: true, class: 'text-left helpWidth150', optional: false, visible: true, design: 'componentState' },
				{ key: 'description', label: this.$t('component.fieldDescription'), trans: 'component.fieldDescription', sortable: true, class: 'text-left', optional: false, visible: false },
				{ key: 'idGroupNavigationName', label: this.$t('component.fieldGroup'), trans: 'component.fieldGroup', sortable: true, class: 'text-left', optional: true, visible: false },
				{ key: 'ipaddressText', label: this.$t('component.fieldIP'), trans: 'component.fieldIP', sortable: true, class: 'text-left', optional: true, visible: false },
				{ key: 'ipaddressVPNText', label: this.$t('receiverDetail.inputIPadressVPN'), trans: 'receiverDetail.inputIPadressVPN', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'ipaddressLocalText', label: this.$t('receiverDetail.inputIPadressLocal'), trans: 'receiverDetail.inputIPadressLocal', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'dateOfConfiguration', label: this.$t('receiverDetail.inputDateOfConfiguration'), trans: 'receiverDetail.inputDateOfConfiguration', sortable: false, class: 'text-left', optional: true, visible: false, formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) } ,
				{ key: 'componentId', label: this.$t('receiverDetail.inputIdentificator'), trans: 'receiverDetail.inputIdentificator', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'programVersion', label: this.$t('receiverDetail.inputProgramVersion'), trans: 'receiverDetail.inputProgramVersion', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'uptime', label: this.$t('receiverDetail.inputUptime'), trans: 'receiverDetail.inputUptime', sortable: false, class: 'text-left', optional: true, visible: false, formatter: (value: string) => tlResponseToUptimeString(value) },
				{ key: 'idComponentTypeNavigationName', label: this.$t('component.fieldType'), trans: 'component.fieldType', sortable: true, class: 'text-left' },
				{ key: 'actions', label: this.$t('component.fieldActions'), trans: 'component.fieldActions', class: 'text-right', thClass: 'lastColumnTable' }
			];
		};

		//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					//{ key: 'idComponentTypeNavigationName', label: this.$t('component.filterType'), trans: 'component.filterType', selected: false, value: null, type: 'text', enum: 'ENU_COR_Component_Type', useEnum: true, refItem: 'idComponentStateNavigationName' },	
					{ key: 'idGroupNavigationName', label: this.$t('component.filterGroup'), trans: 'component.filterGroup', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					{ key: 'componentId', label: this.$t('component.filterIdentif'), trans: 'component.filterIdentif', selected: false, value: null, type: 'text' },
					{ key: 'name', label: this.$t('component.filterName'), trans: 'component.filterName', selected: false, value: null, type: 'text' },
					{ key: 'ipaddressText', label: this.$t('component.filterIP'), trans: 'component.filterIP', selected: false, value: null, type: 'text' },
					{ key: 'ipaddressVPNText', label: this.$t('receiverDetail.inputIPadressVPN'), trans: 'receiverDetail.inputIPadressVPN', selected: false, value: null, type: 'text' },
					{ key: 'ipaddressLocalText', label: this.$t('receiverDetail.inputIPadressLocal'), trans: 'receiverDetail.inputIPadressLocal', selected: false, value: null, type: 'text' },

				];

				var componentTypeEnum = { key: 'ENU_COR_Component_Type', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idComponentTypeNavigationIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('component.filterType'), trans: 'component.filterType', isNegative: true, onlyEnum: 'ENU_COR_Component_Type_Receiver,ENU_COR_Component_Type_TranscoderWorker' };
				var componentGroup = { key: 'ENU_COR_Component_State', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('receiver.filterGroupName'), trans: 'receiver.filterGroupName', isNegative: true };
				super.loadFiltersEnumList([componentGroup, componentTypeEnum]);
			}
	}

	
	detailClickBase(elementId: any) {
		let item = this.tableData.filter((c: any) => c.id == elementId)[0];
	
		if (item.idComponentTypeNavigationIdentifier == "ENU_COR_Component_Type_TranscoderWorker") {
			this.$router.push({ name: this.detailName, params: this.getParams(elementId, "detail"), query: this.getParamsQuery(elementId.toString(), "detail"),  });
		}
		else {
			this.$router.push({ name: "ReceiverDetail", params: this.getParams(elementId, "detail"), query: { id: elementId.toString(), goBack: "ComponentList" } });
		}
	}

	getOptionalParams() {
		return { goBack: "ComponentList" };
	}


	//@ts-ignore
	@Watch('$store.state.currentLanguage')
	changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
		this.setfilters(null);
		this.fetchData();
	}

	};
